export default "__VITE_ASSET__BNAPtSfy__"